import React from "react";

const DoorsWindows = () => {
  return (
    <section className="tc-service-details single-aluminium-spec section-padding">
      {/* Hero Section */}
<div className="page-hero">
  <div className="img position-relative">
    <img
      src="/home2/assets/img/services/window.jpg"
      alt="Doors and Windows"
      className="img-fluid w-100 radius-6"
    />

    {/* Desktop overlay */}
    <div className="info-overlay desktop-only d-flex align-items-end">
      <div className="container pb-40">
        <h1 className="text-white fw-600 fsz-50">Doors & Windows</h1>
        <p className="text-white-50 mt-10 fsz-18">
          Precision-engineered door and window systems that combine style, security, and performance.
        </p>
      </div>
    </div>
  </div>

  {/* Mobile text block (under image) */}
  {/* <div className="info-under mobile-only">
    <div className="container pt-3 pb-3">
      <h1 className="text-dark fw-600 fsz-28">Doors & Windows</h1>
      <p className="text-dark mt-2 fsz-15">
        Precision-engineered door and window systems that combine style, security, and performance.
      </p>
    </div>
  </div> */}
</div>


      {/* Main Content */}
      <div className="container mt-80">
        <div className="row justify-content-between align-items-start">
          <div className="col-lg-12">
            <div className="main-content">
            

              <div className="service-intro mb-80">
                <h2 className="fsz-40 fw-600 mb-30 wow fadeInUp slow" data-wow-delay="0.15s">
                  Aluminium Doors & Windows
                </h2>
                <p className="fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.2s">
                  Our aluminium doors and windows are designed to combine aesthetics, strength, and functionality — perfect for both modern and traditional architecture. Built using high‑grade aluminium profiles, our systems are engineered for exceptional performance, long life, and minimal maintenance.
                </p>
                <p className="fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.25s">
                  We collaborate with leading brands like <strong>Totalis</strong>, <strong>YKK Bhoruka</strong>, and <strong>BWAY</strong>, ensuring every installation meets the highest global standards in durability, weather resistance, and finish quality.
                </p>
                <p className="fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.3s">
                  From design consultation to on‑site installation, every step is handled by our expert in‑house fabrication team at Aluva, Kerala. Each unit is crafted with precision, ensuring a perfect fit, smooth operation, and elegant appearance.
                </p>
              </div>

              <div className="key-benefits mb-80">
                <h3 className="fsz-30 fw-600 mb-30 wow fadeInUp slow" data-wow-delay="0.35s">Why Choose Our Systems?</h3>
                <ul className="dots-list fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.4s">
                  <li className="d-flex my-3"><span className="icon me-3">•</span> Excellent thermal and acoustic insulation.</li>
                  <li className="d-flex my-3"><span className="icon me-3">•</span> Corrosion‑resistant and low‑maintenance performance.</li>
                  <li className="d-flex my-3"><span className="icon me-3">•</span> Customizable designs, colors, and configurations.</li>
                  <li className="d-flex my-3"><span className="icon me-3">•</span> Seamless integration with diverse architectural styles.</li>
                  <li className="d-flex my-3"><span className="icon me-3">•</span> Enhanced security with modern locking mechanisms.</li>
                </ul>
              </div>

              <div className="quality-assurance mb-80">
                <h3 className="fsz-30 fw-600 mb-30 wow fadeInUp slow" data-wow-delay="0.45s">Quality & Lifecycle</h3>
                <p className="fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.5s">
                  At every stage — from raw material selection to final installation — we maintain strict quality control, guaranteeing you a product that performs beautifully for years to come. Whether for residential, commercial, or industrial applications, our aluminium solutions deliver reliability, comfort, and design flexibility.
                </p>
              </div>

              <div className="cta-section mt-10 wow fadeInUp slow text-center" data-wow-delay="0.55s">
                <a href="/contact" className="butn butn-md butn-orange1 radius-30">
                  <span>Request a Custom Aluminium Specification</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DoorsWindows;
